import { render, staticRenderFns } from "./detail-risk.vue?vue&type=template&id=5295afeb&scoped=true"
import script from "./detail-risk.vue?vue&type=script&lang=js"
export * from "./detail-risk.vue?vue&type=script&lang=js"
import style0 from "./detail-risk.vue?vue&type=style&index=0&id=5295afeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5295afeb",
  null
  
)

export default component.exports